import { Route } from 'react-router-dom';
import AdminEspecesPage from '../pages/identification/admin/Espece';
import AdminTypeRace from '../pages/identification/admin/TypeRace';
// import AdminRace from '../pages/identification/admin/Race';
// import AdminTypeProduction from '../pages/identification/admin/TypeProduction 

const IdentificationRoutes = [
  <Route key="espece" path="administration/espece" element={<AdminEspecesPage />} />,
  <Route key="categorie-animal" path="administration/categorie-animal" element={<div>Administration Categorie Animal Page</div>} />,
  <Route key="type-elevage" path="administration/type-elevage" element={<div>Administration Type Elevage Page</div>} />,
  <Route key="motif-mouvement" path="administration/motif-mouvement" element={<div>Administration Motif Mouvement Page</div>} />,
  <Route key="type-race" path="administration/type-race" element={<AdminTypeRace />} />,
  <Route key="race" path="administration/race" element={<div>Administration Race Page</div>} />,
  <Route key="type-production" path="administration/type-production" element={<div>Administration Type Production Page</div>} />,
];

export default IdentificationRoutes;
